export enum DataSource {
  Dexcom = "dexcom",
  DexcomRest = "dexcomrest",
  Nightscout = "nightscout",
  AppleHealthKit = "apple_health_kit",
  Sugarmate = "sugarmate",
}
